export default __webpack_public_path__ + "img/icon_registration_success-32d81c6a1b3052c8b6b3ad324668bf55.png";